<template lang="pug">
.metaContainer(v-loading="loading" element-loading-text="数据更新中...")
  .title 列表页面
  .oper
    el-button(type="primary" plain size="small" @click="addFormDialog") 新建列表页
    el-button(size="small"  :disabled="multipleSelection.length===0" @click="metaDelete") 删 除
  .list
    el-table(border round resizable size="medium" show-overflow keep-source
      ref="xTable" :data="tableData"
      @selection-change="selectChangeEvent",
      :edit-config="{trigger: 'manual', mode: 'row'}")
      el-table-column(type="selection" width="60",align="center")
      el-table-column(type="index" width="60",align="center",label="序号")
      el-table-column(prop="listPageName",align="center", label="列表名称" :edit-render="{}" )
        template(#edit="{ row }")
          el-input(v-model="row.formName" type="text" size="small")
      el-table-column(prop="listPageCode" ,align="center",label="列表编号" :edit-render="{}" )
        template(#edit="{ row }")
          el-input(v-model="row.formCode" type="text" size="small")
      el-table-column(prop="remark",align="center", label="列表页描述" :edit-render="{}" )
        template(#edit="{ row }")
          el-input(v-model="row.remark" type="text" size="small")
      el-table-column(field="primaryMetaName",align="center", label="关联业务模型" :edit-render="{}")
        template(#default="{ row }")
          span {{ getContralName(row.primaryMetaNames)}}
        template(#edit="{ row }")
          el-select(v-model="row.primaryMetaName" transfer size="small")
            el-option(v-for="item in metaList" :key="item.tableName" :value="item.tableName" :label="item.businessName")
      el-table-column(prop="primaryMetaNames",align="center", label="业务模型编号" :edit-render="{}" )
        //- template(#edit="{ row }")
        //-   el-input(v-model="row.remark" type="textarea" size="small")

      el-table-column(field="" ,align="center",label="操作" v-slot="{row}")
        template()
          el-button( size="mini" type="primary" @click="showDetailRow(row)") 编 辑
          el-button( size="mini" type="default" @click="handleClone(row)") 复 制
  addTableDialog(ref="dataDialog" @initTree="initTree" title="编辑")
  cloneListPageDlg(ref="cloneListPageDlg" @ok="queryDynMetaListByGroupID" )
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
import addTableDialog from "./dialog/addTableDialog";
import { getDdynTableList, delDynTableList } from "@/CommonDP/service/listFlow-service.js";
import cloneListPageDlg from "./dialog/cloneListPageDlg";

export default {
  components: { addTableDialog, cloneListPageDlg },
  data () {
    return {
      dataDialog: "",
      tableData: [],
      formData: {},
      loading: false,
      multipleSelection: [],
      metaList: []
    };
  },
  methods: {
    queryList (data) {
      this.formData = data;
      this.queryDynMetaListByGroupID();
    },
    // 获取业务模型列表
    async queryDynMetaListByGroupID () {
      const res = await metadataService.queryDynMetaListByGroupID(this.formData.groupId);
      this.metaList = res.data || [];
      this.dynTableList();
    },
    // 获取列表
    async dynTableList () {
      const res = await getDdynTableList(this.formData.groupId);
      this.tableData = res.data || [];
    },

    selectChangeEvent (records) {
      this.multipleSelection = records;
    },

    initTree () {
      this.$emit('initTree');
    },
    async saveRowEvent ({ formId, formCode, remark, formName, formGroupId, formGroupName, primaryMetaName }) {
      const params = {
        formId, formName, formGroupId, formGroupName, primaryMetaName, formCode, remark,
        isPublish: 0,
        otherMetaNames: '',
        stdFormName: '',
        flowKey: ''
      };
      await metadataService.dynFormUpdate(params);
      this.$success("操作成功");
      const $table = this.$refs.xTable;
      $table.clearActived();
    },
    cancelRowEvent (row) {
      const $table = this.$refs.xTable;
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row);
      });
    },
    metaDelete () {
      this.$confirm(`确认删除选中的数据吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.loading = true;
        const batchIdList = this.multipleSelection.map(e => e.listPageId);
        await delDynTableList(batchIdList);
        this.$emit('initTree');
        this.queryDynMetaListByGroupID();
        this.$success("操作成功");
        this.loading = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 更新统计表数据
    update () {
      this.queryDynMetaListByGroupID();
    },
    addFormDialog () {
      this.$emit('openTypeDialog', this.formData, "addTable");
    },
    // 业务模型详情
    async showDetailRow (row) {
      this.$refs.dataDialog.init(row);
    },

    handleClone(row) {
      this.$refs.cloneListPageDlg.show(row);
    },

    getContralName (enName) {
      const arr = enName.split(',');
      const value = arr.map(item => {
        return this.metaList.find(e => e.tableName === item)?.businessName;
      });
      return value.join(',');
    }
  }

};
</script>

<style lang="scss" scoped>
.metaContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .title {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: 10px 0;
    line-height: 25px;
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
  }

  .oper {
    padding: var(--middle-space) 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

/deep/.el-table--render-default.el-editable .el-body--column,
.el-table--render-default.el-editable .el-body--column.col--actived {
  padding: 11px 0
}
</style>
